exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disclaimer-message{margin-left:8px;color:#121212}.disclaimer-container,.disclaimer-message{font-size:12px;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.6;letter-spacing:normal}.disclaimer-container{padding-left:16px;display:-ms-flexbox;display:flex;font-family:BentonSansBBVA Book,Helvetica Neue,Arial,Helvetica,sans-serif;color:#b92a45;font-size:15px}.centrado{-ms-flex-pack:center;justify-content:center;padding-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/components/Disclaimer.css
// module id = 571
// module chunks = 0 5 8 9